import React, { useContext } from "react";
import "./styles";
import { PagamentoCombinarContainer } from "./styles";
import { Input } from "../../Input";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { CatalogoContext } from "../../../contexts/Catalogo/CatalogoContext";
import { deepCopy } from "../../../services/Functions";
import Configuracoes from "../../../types/Configuracoes";

interface PagamentoCombinarProps {
  configIn: "empresa" | "configuracoes" | "catalogo";
}

const PagamentoCombinar: React.FC<PagamentoCombinarProps> = ({ configIn }) => {
  const configsEmpresa = useContext(ConfiguracoesContext);
  const configsCatalogo = useContext(CatalogoContext);
  const { theme } = useTheme();

  const configuracoes =
    configIn === "catalogo"
      ? configsCatalogo.catalogo
      : configsEmpresa.configuracoes;
  const setConfiguracoes =
    configIn === "catalogo"
      ? configsCatalogo.setCatalogo
      : configsEmpresa.setConfiguracoes;
  const ignoreValidation =
    configIn === "catalogo"
      ? false
      : !(configuracoes as Configuracoes).pagamentoCombinarAtivo;

  return (
    <PagamentoCombinarContainer configIn={configIn} theme={theme}>
      <div className="descricao-texto fonteTexto">
        Permite que seu cliente faça o pedido e acerte a forma de pagamento diretamente com você. 
        Defina o prazo para entrar em contato após a compra e ofereça flexibilidade na negociação.
      </div>
      <div className="input-container">
        <Input
          ignoreValidations={ignoreValidation}
          type={"number"}
          value={
            configuracoes.intermediadores.a_combinar?.prazo_contato &&
            Number.parseInt(
              configuracoes.intermediadores.a_combinar?.prazo_contato,
            ) > 0
              ? configuracoes.intermediadores.a_combinar.prazo_contato.toString()
              : ""
          }
          placeholder={"2"}
          required={true}
          alignLabel="left"
          label="Prazo em dias para você entrar em contato com o cliente"
          onChange={(newValue) => {
            setConfiguracoes(
              deepCopy(configuracoes, {
                intermediadores: {
                  a_combinar: {
                    prazo_contato: newValue,
                    ativo:
                      configIn === "catalogo"
                        ? true
                        : (configuracoes as Configuracoes).pagamentoCombinarAtivo,
                  },
                },
              }),
            );
          }}
        />
      </div>
    </PagamentoCombinarContainer>
  );
};

export default PagamentoCombinar;
